import styled from "styled-components";

export const StyledTooltipContent = styled.span`
    white-space: pre;
`;
